import { trackMixpanel } from '../../mixpanel/base';
import { CardViewMixpanelData, CardViewMixpanelProps } from './types';

const COMPONENT = 'Delivery Card';
const MIXPANEL_EVENT_NAME = 'View';

const toMixpanelProps = ({
    positionInFeed,
    deliveryId,
    gigId,
    sellerId,
    itemType,
    subCategoryId,
    width,
    height,
    platform,
    component,
    componentType,
    pageName,
    price,
    subCategoryName,
    nestedSubCategoryName,
    nestedSubCategoryId,
}: CardViewMixpanelProps): CardViewMixpanelData => ({
    'Position in feed': positionInFeed,
    'Delivery Id': deliveryId,
    'Gig Id': gigId,
    'Seller Id': sellerId,
    'Item type': itemType,
    'Subcategory Id': subCategoryId,
    'Nested Sub Category Id': nestedSubCategoryId,
    Width: width,
    Height: height,
    Platform: platform,
    Component: component,
    'Component Type': componentType,
    'Page Name': pageName,
    'Min Package Price': price,
    'Subcategory Name': subCategoryName,
    'Nested Subcategory Name': nestedSubCategoryName,
});

export const trackMixpanelCardView = (props: CardViewMixpanelProps) => {
    trackMixpanel(COMPONENT, MIXPANEL_EVENT_NAME, { ...toMixpanelProps(props), ...(props.enrichment ?? {}) });
};
